import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=55ff79f1&scoped=true&"
import script from "./portfolio.vue?vue&type=script&lang=js&"
export * from "./portfolio.vue?vue&type=script&lang=js&"
import style0 from "./portfolio.vue?vue&type=style&index=0&id=55ff79f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff79f1",
  null
  
)

export default component.exports